import React, { FunctionComponent } from "react";

import { Icon, IconColor, JustifyContent, Layout } from "@multiweb/reactComponents";
import { IconCode } from "@multiweb/types/contracts";
import { DropdownArrowDirection } from "./types";

/** Ikona pro směr nahoru */
const UP_ICON = IconCode.uiChevronTopSmallFilled;
/** Ikona pro směr dolů */
const DOWN_ICON = IconCode.uiChevronBottomSmallFilled;
/** Barva ikony v připadě active=true */
const ACIVE_COLOR = IconColor.colorPrimary;
/** Barva ikony v připadě active=false */
const INACTIVE_COLOR = IconColor.textDisabled;

export type DropdownContainerOverflowArrowProps = {
    /** Směr šípky */
    direction: DropdownArrowDirection;
    /** Aktivnost šipky */
    active: boolean;
};

export const DropdownContainerOverflowArrow: FunctionComponent<DropdownContainerOverflowArrowProps> = ({
    direction,
    active,
}) => <Layout justifyContent={JustifyContent.center}><Icon iconCode={direction === DropdownArrowDirection.up ? UP_ICON : DOWN_ICON} color={active ? ACIVE_COLOR : INACTIVE_COLOR} /></Layout>;
